import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid2';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FielderButton from 'FielderComponents/FielderButton';
import { StyleFielderTitleTypography } from '~/FielderElements/FielderElements.styles';

class GeneratePdfFromXlsx extends Component {
  render() {
    const { lan, onClose, urlGeneratePdfFromXlsx, approve, cancel, open = true } = this.props;
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth={false}
        fullWidth={false}
        scroll="paper"
        aria-labelledby="generate-template-pdf-title"
        sx={{
          '& .MuiDialog-container': { alignItems: 'center' },
        }}
        slotProps={{
          paper: {
            sx: {
              maxWidth: 'none',
              width: '90%',
              maxHeight: '90vh',
            },
          },
        }}
      >
        {/* Header */}
        <DialogTitle id="generate-template-pdf-title" sx={{ p: 0 }}>
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              py: 1.25,
              px: 2,
            }}
          >
            <StyleFielderTitleTypography variant={'subtitle1'}>
              {lan.generatePDFfromXlsx}
            </StyleFielderTitleTypography>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        {/* Body */}
        <DialogContent dividers sx={{ px: 0, pt: 0 }}>
          <Box sx={{ mx: 2, mt: 1, overflowX: 'hidden', height: 660 }}>
            <Grid container sx={{ height: '100%' }}>
              <Grid size={12} sx={{ height: '100%', p: 0 }}>
                <Scrollbars
                  autoHide
                  style={{ width: '100%', height: '100%', overflowY: 'hidden' }}
                >
                  <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
                    <Box
                      component="iframe"
                      title={lan.generatePDFfromXlsx}
                      src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                        urlGeneratePdfFromXlsx
                      )}`}
                      sx={{
                        width: '100%',
                        height: '100%',
                        border: 0,
                        display: 'block',
                      }}
                      loading="lazy"
                      referrerPolicy="no-referrer"
                      allowFullScreen
                    />
                  </Box>
                </Scrollbars>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        {/* Footer */}
        <DialogActions sx={{ px: 2, pb: 2, pt: 0 }}>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            sx={{ width: '100%', gap: 2 }}
          >
            <Grid size={3}>
              <FielderButton
                id="generate-pdf-form-module"
                onClick={() => approve(urlGeneratePdfFromXlsx)}
                outlined
                style={{ width: '100%' }}
              >
                {lan.approve}
              </FielderButton>
            </Grid>
            <Grid size={3}>
              <FielderButton
                id="generate-pdf-form-module"
                onClick={cancel}
                outlined
                style={{ width: '100%' }}
              >
                {lan.cancel}
              </FielderButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    );
  }
}
GeneratePdfFromXlsx.propTypes = {
  lan: PropTypes.shape({
    generatePDFfromXlsx: PropTypes.string.isRequired,
    approve: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  urlGeneratePdfFromXlsx: PropTypes.string.isRequired,
  approve: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  open: PropTypes.bool,
};
export default GeneratePdfFromXlsx;
//Original code:
/*import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars-2';
import FielderButton from 'FielderComponents/FielderButton';
import Popup from '../Popup';

class GeneratePdfFromXlsx extends Component {
	render() {
		const { lan, onClose, urlGeneratePdfFromXlsx, approve, cancel } = this.props;
		return (
			<Popup
				title={lan.generatePDFfromXlsx}
				centered
				width='xl'
				onClose={onClose}
				dialogClassName='centered-modal-pdf'
				propsContainer='pdf-container-size'
				closeButton
			>
				<Container className='no-padding no-margin' style={{ maxWidth:'100%', height: '660px' }}>
					<div style={{ height: '80%' }} className='mt-4'>
						<Scrollbars style={{ height: '100%', overflowY: 'hidden' }}>
							<div className='row-12'>
								<iframe
									src={`https://view.officeapps.live.com/op/embed.aspx?src=${urlGeneratePdfFromXlsx}`}
									width='100%'
									height='500px'
									frameBorder={0}
								/>
							</div>
						</Scrollbars>
						<Row className='my-3'>
							<Col sm={3} className='mx-auto'>
								<FielderButton id='generate-pdf-form-module' onClick={() => approve(urlGeneratePdfFromXlsx)} outlined>
									{lan.approve}
								</FielderButton>
							</Col>
							<Col sm={3} className='mx-auto'>
								<FielderButton id='generate-pdf-form-module' onClick={cancel} outlined>
									{lan.cancel}
								</FielderButton>
							</Col>
						</Row>
					</div>
				</Container>
			</Popup>
		);
	}
}

GeneratePdfFromXlsx.propTypes = {
	lan: PropTypes.shape({
		generatePDFfromXlsx: PropTypes.string.isRequired,
		approve: PropTypes.string.isRequired,
		cancel: PropTypes.string.isRequired,
	}).isRequired,
	onClose: PropTypes.func.isRequired,
	urlGeneratePdfFromXlsx: PropTypes.string.isRequired,
	approve: PropTypes.func.isRequired,
	cancel: PropTypes.func.isRequired,
};

export default GeneratePdfFromXlsx;
*/
